/* import __COLOCATED_TEMPLATE__ from './end-user-auth.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type SunshineConfiguration from 'embercom/models/standalone/sunshine-configuration';

export interface Args {
  isSaving?: boolean;
  hideIcon?: boolean;
  showRed?: boolean;
}

export default class EndUserAuthPill extends Component<Args> {
  @service declare finStandaloneService: FinStandaloneService;

  get isDisconnected() {
    return !this.sunshineConfig || !this.sunshineConfig.endUserAuthEnabled;
  }

  get sunshineConfig(): SunshineConfiguration | undefined {
    return this.finStandaloneService.zendeskConfig?.sunshineIntegration;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Pills::EndUserAuth': typeof EndUserAuthPill;
    'standalone/zendesk/pills/EndUserAuth': typeof EndUserAuthPill;
  }
}
